import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import MapPicker from '../Shared/MapPicker.vue';

export default {
    name: 'Schools',
    mixins: [HelperMixin],
    components: {
        PaginationHelper,
        MapPicker
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // Schools list — Admin (1) + School owner (40) only. The backend
        // SchoolsController.Get/GetAll reject UserType 41 (HTTP 400), so
        // admitting 41 here would land them on a permanently-empty page. Use
        // the shared requireUserType helper (cleaner than a raw logout). If 41
        // school-admins should ever see this screen, the backend endpoint must
        // be widened + scoped first.
        if (!this.requireUserType([1, 40])) return;

        this.GetInfo(this.pageNo);
        this.GetCities();
        this.GetLocations();
        // طرق الدفع لازم تتحمّل هنا (زي باقي شاشات المدارس) وإلا قائمة
        // «طريقة الدفع» في مودال شحن المحفظة تفضل فاضية. GetAllPaymentMethods
        // من HelperMixin يعبّي this.PaymentMethods.
        this.GetAllPaymentMethods();
    },


    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }, availableUsers() {
            const all = this.allUsers || [];
            const linked = this.UsersInfo || [];

            // نكوّن Set بأرقام المستخدمين المرتبطين بالفعل
            const linkedIds = new Set(
                linked
                    .map(u => Number(u.userId))
                    .filter(v => !isNaN(v))
            );

            // نرجّع فقط اللي مش موجودين في الربط
            return all.filter(u => !linkedIds.has(Number(u.id)));
        }
    },

    data() {
        return {
            walletTab: 'tx',
            schoolId: null,      // حط هنا id المدرسة (من route أو من selectedSchoolId)
            schoolName: '',

            walletInfo: [],
            walletPurchases: [],
            walletTracker: [],
            saving: false,
            chargeForm: {
                SchoolsId: null,
                Value: null,
                PaymentMethodId: null
            },

            PaymentMethods: [] ,
            selectedSchoolId: null,

            subForm: {
                SchoolsId: null,
                SubscriptionsTypeId: '',
                Value: null
            },
            subValueForm: {
                Id: null,
                Value: null
            },
            // الباقات
            SubscriptionsTypes: [],
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            SchoolName:'',
            Search: '',
            SubscriptionsInfo: {},
            ScreenTitle: '  المدارس ',
            ScreenTitleSingle: '  مدرسة   ',
            ScreenTitleSingleAl: ' المدرسة  ',

            Info: [],
            Statistics: [],
            LocationsId:null,
            AddDialog: false,

            SelectedItem: '',
            state:0,
            ruleForm: {
                Id: '',
                Name: '',
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
                LocationsId: '',
                AdressLine1: '',
                Latitude: null,
                Longitude: null,
                Descriptions: '',
                MonthlyRatePerStudent: null,

                // Helper for cascading
                CityId: '',
                MunicipalityId: ''
            },
            // BUG-06: map-picker model for the school location.
            mapValue: { lat: null, lng: null },

            // Validation Rules
            rules: {
                Name: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                Email: this.$helper.EmailOnly(),
                LocationsId: this.$helper.Required(),
            },
            dropForm: {
                Id: null,
                DropResone: ''
            },

            // Dropdown Data
            Cities: [],
            Municipalities: [],
            Locations: [],

            // Revised School Users
            UsersListDialog: false,
            AddUserDialog: false,
            UsersInfo: [],
            allUsers: [],
            selectedUserId: '',
            userSearch: '',
            userPageNo: 1,
            userPageSize: 10,
            userTotal: 0,
            searchTimeout: null,
        };
    },



    methods: {

        prepareWalletCharge(item) {

            this.chargeForm = {
                SchoolsId: item.id,
                Value: null,
                PaymentMethodId: null
            };

            // طرق الدفع محمّلة مسبقاً في created() عبر GetAllPaymentMethods().
        },

        submitWalletCharge() {

            const form = document.getElementById('chargeWalletForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');

            this.$blockUI.Start();

            this.$http.ChargeWallet(this.chargeForm)
                .then((res) => {
                    this.$blockUI.Stop();

                    // إغلاق المودال بنفس طريقتك
                    this.$helper.DestroyElemntById('CloseChargeWallet');

                    // تصفير
                    this.chargeForm.Value = null;
                    this.chargeForm.PaymentMethodId = null;

                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);

                    // تحديث جدول المحفظة (الرصيد + سجل المعاملات) بعد الشحن.
                    // مودال الشحن يُفتح فقط من شاشة المحفظة (state 3) حيث schoolId
                    // مُعرّف، فالتحديث آمن. كان معطّلاً = الجدول ما يحدّث بعد الإضافة.
                    if (this.schoolId) {
                        this.GetWallet();
                    }
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response?.data || 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        async openWallet(item) {

            // نخزن id المدرسة
            this.schoolId = item.id;
            this.schoolName = item.name;

            // نغير الصفحة/التبويب
            this.state = 3;   // رقم صفحة المحفظة عندك (عدّل حسب مشروعك)

            // نجيب البيانات
            await this.GetWallet();
        },
        GetWallet() {

            this.$blockUI.Start();

            this.$http.GetWallet(this.schoolId)
                .then((res) => {
                    this.$blockUI.Stop();

                    this.walletInfo = res.data.info;
                    this.walletPurchases = res.data.infoPurchases;
                    this.walletTracker = res.data.infoTracker;
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let msg = err.response?.data || 'حدث خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        OpenAddSubValueModal(item) {
            this.subValueForm.Id = item.id;   // subscriptionId
            this.subValueForm.Value = null;
        }
,
        OpenDropModal(item) {
            this.dropForm.Id = item.id;
            this.dropForm.DropResone = '';
        },submitAddSubValue() {

            const form = document.getElementById('addSubValueForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى إدخال قيمة صحيحة');
                return;
            }

            form.classList.remove('was-validated');

            this.$blockUI.Start();

            this.$http.AddSubscriptionValue(this.subValueForm)
                .then((res) => {
                    this.$blockUI.Stop();

                    this.GetSchoolSubscriptions(this.selectedSchoolId);  // تحديث الجدول

                    // تصفير
                    this.subValueForm.Value = null;

                    // إغلاق مودال
                    this.$helper.DestroyElemntById('CloseAddSubValue');

                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response?.data || 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

         ConfirmDropSubscription() {

            if (!this.dropForm.DropResone || this.dropForm.DropResone.trim() === '') {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى كتابة سبب الانسحاب');
                return;
            }

            this.$blockUI.Start();

            this.$http.DropSchoolSubscription(this.dropForm)
                .then((res) => {
                    this.$blockUI.Stop();

                    this.GetSchoolSubscriptions(this.selectedSchoolId);  // تحديث الجدول

                    this.$helper.DestroyElemntById('CloseDropSubscription');

                    this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response?.data || 'حدث خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        submitSubscription() {

            const form = document.getElementById('addSubscriptionForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');

        
            if (!this.subForm.SchoolsId || this.subForm.SchoolsId <= 0) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'لم يتم تحديد المدرسة');
                return;
            }

            this.$blockUI.Start();

            this.$http.AddSchoolSubscription(this.subForm)
                .then((response) => {
                    this.$blockUI.Stop();

                    this.GetSchoolSubscriptions(this.selectedSchoolId); // تحديث الجدول

                    // تصفير فورم
                    this.subForm.SubscriptionsTypeId = null;
                    this.subForm.Value = null;

                    // إغلاق المودال بنفس طريقتك
                    this.$helper.DestroyElemntById('CloseAddSubscription');

                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        }
,

        async GetSubscriptionsTypes() {
            this.$blockUI.Start();
            this.$http.GetAllSubscriptionsTypes()
                .then(response => {
                    this.$blockUI.Stop();
                    // Controller returns { info: [...] }
                    this.SubscriptionsTypes = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.UsersInfo = [];
                });
        },
        DeleteSubscription(item) {

            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من حذف الاشتراك؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، حذف',
                cancelButtonText: 'إلغاء'
            }).then((result) => {

                if (!result.isConfirmed) return;

                this.$blockUI.Start();

                const schoolId = this.selectedSchoolId || this.schoolId || item.schoolsId;
                const subscriptionId = item.id;

                this.$http.DeleteSchoolSubscription(schoolId, subscriptionId)
                    .then((res) => {
                        this.$blockUI.Stop();
                        this.GetSchoolSubscriptions(schoolId);
                        this.$helper.ShowMessage('success', 'عملية ناجحة', res.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        const msg = err.response?.data || 'حدث خطأ غير متوقع';
                        this.$helper.ShowMessage('error', 'خطأ', msg);
                    });

            });
        },

        async prepareSubscription() {

            this.subForm = {
                SchoolsId: this.SelectedItem.id,
                SubscriptionsTypeId: '',
                Value: null
            };

            this.selectedSchoolId = this.SelectedItem.id;

            await this.GetSubscriptionsTypes();
        }
        , 


        applyFilters() {
            this.pageNo = 1;
            this.GetInfo(this.pageNo);
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            // لو مستخدم مدرسة نجيب مدرسته بس
            const schoolUserId = this.loginDetails && this.loginDetails.userType == 40
                ? this.loginDetails.id
                : null;

            this.$http.GetSchools(this.pageNo, this.pageSize, this.Search, '', schoolUserId)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },


        // --- Cascading Dropdowns Logic ---

        GetCities() {
            this.$http.GetAllCities()
                .then(response => {
                    this.Cities = response.data.info;
                })
                .catch(() => {
                    this.Cities = [];
                });
        },

        onCityChange() {
            this.ruleForm.MunicipalityId = '';
            this.ruleForm.LocationsId = '';
            this.Municipalities = [];
            this.Locations = [];

            if (this.ruleForm.CityId) {
                this.GetMunicipalities(this.ruleForm.CityId);
            }
        },

        GetMunicipalities(cityId) {
            this.$http.GetAllMunicipalities(cityId)
                .then(response => {
                    this.Municipalities = response.data.info;
                })
                .catch(() => {
                    this.Municipalities = [];
                });
        },
        formatMoney(value) {
            // Pin the locale. Bare toLocaleString() follows the BROWSER locale, so on an
            // Arabic browser this rendered Arabic-Indic digits (٤٤٬١٢٣) while the rest of
            // the dashboard shows Latin ones — and the `!value` early-return made 0 the only
            // consistent case. Everything now goes through the same en-US path.
            const n = Number(value) || 0;
            return n.toLocaleString('en-US') + " د.ل";
        },
        onMunicipalityChange() {
            this.ruleForm.LocationsId = '';
            this.Locations = [];

            if (this.ruleForm.MunicipalityId) {
                this.GetLocations(this.ruleForm.MunicipalityId);
            }
        },

        GetLocations(municipalityId) {
            this.$http.GetAllLocations(municipalityId)
                .then(response => {
                    this.Locations = response.data.info;
                })
                .catch(() => {
                    this.Locations = [];
                });
        },

        // -------------------------------

        // BUG-06: reset the form AND the map model when opening the Add dialog so
        // a previous edit's coordinates never leak into a new school.
        openAddSchoolDialog() {
            this.ClearForm(this.ruleForm);
            this.ruleForm.Latitude = null;
            this.ruleForm.Longitude = null;
            this.ruleForm.MonthlyRatePerStudent = null;
            this.mapValue = { lat: null, lng: null };
            this.Municipalities = [];
            this.Locations = [];
        },

        // BUG-06: a school must have a map-picked location (Add + Edit). MapPicker
        // is a custom component, so HTML checkValidity() cannot enforce it. Libya
        // coordinates are never 0, so a falsy lat/lng means "not picked".
        requireMapLocation() {
            if (!this.ruleForm.Latitude || !this.ruleForm.Longitude) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى تحديد موقع المدرسة على الخريطة');
                return false;
            }
            return true;
        },

        submitForm() {

            const form = document.getElementById('addSchoolForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            if (!this.requireMapLocation()) return;

            form.classList.remove('was-validated');
            this.ruleForm.Id = Number(0);

            // v-model.number يرجّع '' عند مسح الحقل — نحوّلها null حتى لا يفشل
            // ربط decimal? في الباك-إند.
            if (this.ruleForm.MonthlyRatePerStudent === '')
                this.ruleForm.MonthlyRatePerStudent = null;

            this.$blockUI.Start();
            this.$http.AddSchools(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);

                    // Reset Cascading dropdowns
                    this.ruleForm.CityId = '';
                    this.ruleForm.MunicipalityId = '';
                    this.ruleForm.LocationsId = '';
                    this.Municipalities = [];
                    this.Locations = [];

                    this.$helper.DestroyElemntById('CloseAdd'); // Close modal
                    // Guard against non-string payloads rendering as "[object Object]".
                    this.$helper.ShowMessage('success', 'عملية ناجحة',
                        typeof response.data === 'string' ? response.data : 'تمت إضافة المدرسة بنجاح');
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        Back() {
            this.Info = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },

        // --- Revised School Users Logic ---
        OpenUsersList(item) {
            this.SelectedItem = item;
            this.UsersListDialog = true;
            this.state = 1;
            this.SchoolName = item.name;
          
            this.GetSchoolUsers(item.id);
        }, openSubscriptions(item) {
            this.SelectedItem = item;
            this.UsersListDialog = true;
            this.state = 2;
            this.SchoolName = item.name;

            this.GetSchoolSubscriptions(item.id);
        },

        OpenAddUser(item) {
            this.SelectedItem = item;
            this.AddUserDialog = true;
            this.selectedUserId = '';
            this.userSearch = '';
            this.GetAllUsersList(1);
        },
        GetSchoolUsers(schoolId) {
            this.$blockUI.Start();
            this.$http.GetSchoolUsers(schoolId)
                .then(response => {
                    this.$blockUI.Stop();
                    // Controller returns { info: [...] }
                    this.UsersInfo = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.UsersInfo = [];
                });
        },
        GetSchoolSubscriptions(schoolId) {
            this.$blockUI.Start();
            this.$http.GetSchoolSubscriptions(schoolId)
                .then(response => {
                    this.$blockUI.Stop();
                    // Controller returns { info: [...] }
                    this.SubscriptionsInfo = response.data.info || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.UsersInfo = [];
                });
        },

        GetAllUsersList(pageNo) {
            this.userPageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetUsers(this.userPageNo, this.userPageSize, this.userSearch)
                .then(response => {
                    this.$blockUI.Stop();
                    this.allUsers = response.data.info || [];
                    this.userTotal = response.data.count || 0;
                    console.log(this.allUsers?.[0], this.UsersInfo?.[0]);
                    // Reset selection when results change unless we are just paging
                    if (pageNo === 1) this.selectedUserId = '';
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.allUsers = [];
                    this.userTotal = 0;
                });
        },

        handleUserSearch() {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.GetAllUsersList(1);
            }, 500); // 500ms debounce
        },

        submitUserForm(userId) {
            const finalUserId = userId || this.selectedUserId;
            if (!this.SelectedItem || !finalUserId) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى اختيار مستخدم');
                return;
            }

            this.$blockUI.Start();
            const body = {
                SchoolsId: this.SelectedItem.id,
                UserId: finalUserId
            };

            this.$http.AddSchoolUser(body)
                .then(response => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'نجاح', response.data);
                    this.AddUserDialog = false;
                    this.$helper.DestroyElemntById('CloseUserModal');
                    // Refresh school users list if it was open
                    if (this.UsersListDialog) {
                        this.GetSchoolUsers(this.SelectedItem.id);
                    }
                })
                .catch(err => {
                    this.$blockUI.Stop();
                    let msg = err.response && err.response.data ? err.response.data : 'فشل ربط المستخدم';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        DeleteUser(userId) {
            Swal.fire({
                title: 'تأكيد الحذف',
                text: 'هل أنت متأكد من إلغاء ربط هذا المستخدم بالمدرسة؟',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، احذف',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteSchoolUser(userId)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'نجاح', 'تم حذف المستخدم');
                            this.GetSchoolUsers(this.SelectedItem.id);
                        })
                        .catch(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('error', 'خطأ', 'فشل الحذف');
                        });
                }
            });
        },

        ChangeUserStatus(user) {
            // Toggle Status: 1 -> 3 (Suspend), 3 -> 1 (Active)
            let newStatus = user.status === 1 ? 3 : 1;
            let actionName = newStatus === 3 ? 'تعليق' : 'تفعيل';

            Swal.fire({
                title: `تأكيد ${actionName} المستخدم`,
                text: `هل أنت متأكد من ${actionName} هذا المستخدم؟`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم',
                cancelButtonText: 'إلغاء'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    let body = {
                        Id: user.id, // SchoolUserId
                        SchoolsId: user.schoolsId,
                        UserId: user.userId,
                        Status: newStatus
                    };

                    this.$http.EditSchoolUser(body)
                        .then(() => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'نجاح', `تم ${actionName} المستخدم`);
                            this.GetSchoolUsers(this.SelectedItem.id);
                        })
                        .catch(err => {
                            this.$blockUI.Stop();
                            let msg = err.response && err.response.data ? err.response.data : 'فشل تغيير الحالة';
                            this.$helper.ShowMessage('error', 'خطأ', msg);
                        });
                }
            });
        },


        OpentEditDialog(item) {
            this.SelectedItem = item;
            // ruleForm is SHARED with the Add dialog. An image picked in Add and then
            // cancelled stayed in ruleForm.Image, so the next Edit save silently re-uploaded
            // it and replaced that school's picture even though the operator never touched
            // the image field. Clear it — Edit keeps the stored image unless a new file is
            // explicitly chosen.
            this.ruleForm.Image = '';
            this.ruleForm.ImageName = '';

            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;

            this.ruleForm.AdressLine1 = item.adressLine1;
            this.ruleForm.Descriptions = item.descriptions;

            // Get Full Details including CityId and MunicipalityId
            this.$blockUI.Start();
            this.$http.GetSchoolById(item.id).then(res => {
                this.$blockUI.Stop();
                const school = res.data;

                this.ruleForm.LocationsId = school.locationsId;
                this.ruleForm.AdressLine1 = school.adressLine1;
                this.ruleForm.Descriptions = school.descriptions;
                this.ruleForm.MonthlyRatePerStudent = school.monthlyRatePerStudent != null ? school.monthlyRatePerStudent : null;
                // BUG-06: prefill the map location.
                this.ruleForm.Latitude = school.latitude != null ? school.latitude : null;
                this.ruleForm.Longitude = school.longitude != null ? school.longitude : null;
                this.mapValue = { lat: school.latitude, lng: school.longitude };

                // Pre-fill Cascading Dropdowns
                if (school.cityId) {
                    this.ruleForm.CityId = school.cityId;
                    this.GetMunicipalities(school.cityId);
                }
                if (school.municipalityId) {
                    this.ruleForm.MunicipalityId = school.municipalityId;
                    this.GetLocations(school.municipalityId);
                }

                // Finally set Location again to ensure it's selected after list load
                // Note: JS is async, but Vue reactivity *should* handle the binding once the list arrives.
                // If not, we might need to chain promises, but this is usually sufficient in Vue 2/3.
                this.ruleForm.LocationsId = school.locationsId;

            }).catch(err => {
                this.$blockUI.Stop();
                console.error("Failed to fetch school details", err);
            });
        },

        submitEditForm() {
            const form = document.getElementById('editSchoolForm');

            if (!form.checkValidity()) {
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            if (!this.requireMapLocation()) return;

            form.classList.remove('was-validated');
            // Convert Id to Number
            this.ruleForm.Id = Number(this.ruleForm.Id);

            // v-model.number يرجّع '' عند مسح الحقل — نحوّلها null حتى لا يفشل
            // ربط decimal? في الباك-إند (null = الإبقاء على القيمة الحالية).
            if (this.ruleForm.MonthlyRatePerStudent === '')
                this.ruleForm.MonthlyRatePerStudent = null;

            this.$blockUI.Start();
            this.$http.EditSchools(this.ruleForm)
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('CloseEdit');
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', errorMsg);
                });
        },

        // Status Management: Suspend / Cancel Suspend
        ChangeStatus(item) {
            // Check current status
            // If Active (1) -> Suspend
            // If Suspended (3) -> Cancel Suspend

            // Note: Use item.status from the list iteration

            if (item.activeSubscription && item.activeSubscription.id) {
                // Check logic for subscriptions if needed, mostly checking status
            }

            // If status is Active (1), we Suspend
            if (item.status == 1) {
                Swal.fire({
                    title: 'تعليق المدرسة',
                    input: 'text',
                    inputLabel: 'سبب التعليق',
                    inputPlaceholder: 'أدخل سبب التعليق...',
                    showCancelButton: true,
                    confirmButtonText: 'تعليق',
                    cancelButtonText: 'إلغاء',
                    inputValidator: (value) => {
                        if (!value) {
                            return 'يجب إدخال سبب التعليق!'
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.SuspendSchools(item.id, { Resone: result.value })
                            .then((response) => {
                                this.$blockUI.Stop();
                                this.$helper.ShowMessage('success', 'تم التعليق', response.data);
                                this.GetInfo(this.pageNo);
                            })
                            .catch((err) => {
                                this.$blockUI.Stop();
                                let msg = err.response && err.response.data ? err.response.data : 'خطأ';
                                this.$helper.ShowMessage('error', 'خطأ', msg);
                            });
                    }
                });
            }
            // If status is Suspended (3), we Activate (Cancel Suspend)
            else {
                Swal.fire({
                    title: 'تفعيل المدرسة',
                    text: 'هل أنت متأكد من إلغاء التعليق وتفعيل المدرسة؟',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'تفعيل',
                    cancelButtonText: 'إلغاء'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.$blockUI.Start();
                        this.$http.CancelSuspendSchools(item.id)
                            .then((response) => {
                                this.$blockUI.Stop();
                                this.$helper.ShowMessage('success', 'تم التفعيل', response.data);
                                this.GetInfo(this.pageNo);
                            })
                            .catch((err) => {
                                this.$blockUI.Stop();
                                let msg = err.response && err.response.data ? err.response.data : 'خطأ';
                                this.$helper.ShowMessage('error', 'خطأ', msg);
                            });
                    }
                });
            }
        },



        Delete(Id) {
            // Audit P1 #12 — the hard-delete endpoint only removes a genuinely EMPTY
            // school (no students/users/subscriptions/trips/driver-links/invoices). For an
            // active school the safe, reversible action is "تعليق المدرسة" (Suspend); the
            // backend refusal returned here also reminds the admin of that.
            Swal.fire({
                title: 'حذف المدرسة نهائياً',
                text: 'الحذف النهائي متاح فقط للمدارس الفارغة (بدون طلاب أو مستخدمين أو اشتراكات أو رحلات أو سائقين أو فواتير). لإيقاف مدرسة فعّالة عن العمل استخدم "تعليق المدرسة" بدلاً من الحذف. هل تريد المتابعة؟',
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'إلغاء',
                customClass: {
                    confirmButton: 'btn btn-danger'
                },
                buttonsStyling: false,
                confirmButtonText: `حذف نهائي`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteSchools(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type;
            str = str.substring(0, 5);

            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },


        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

    }
}
